import { render, staticRenderFns } from "./ClassRoomList.vue?vue&type=template&id=8de44b4a&scoped=true&"
import script from "./ClassRoomList.vue?vue&type=script&lang=js&"
export * from "./ClassRoomList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8de44b4a",
  null
  
)

export default component.exports